import Vue from 'vue'
import { Mentionable } from 'vue-mention'

Vue.component('mentionable', Mentionable)
